import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import MatchReplay from "./MatchReplay";
import { fetchReplay, REPLAY_DAYS, type PlayerReplay } from "../../../shared/replays";
import styles from "./ReplayPage.module.scss";

// /replay?match=<id>: a finished online match, watchable by whoever has the link
// (the profile's match list links here). ?round=N opens on that round.
export default function ReplayPage() {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const matchId = search.get("match") || "";
  const round = Math.max(1, Number(search.get("round")) || 1) - 1;
  const [replay, setReplay] = useState<PlayerReplay | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let live = true;
    setReplay(null);
    setError(null);
    fetchReplay(matchId, search.get("server")).then((res) => {
      if (!live) return;
      if ("error" in res) setError(res.error);
      else if (!res.match.matchState.roundsData.length) setError("gone");
      else setReplay(res);
    });
    return () => { live = false; };
  }, [matchId]);

  // Back to where you came from (the profile), or home on a link opened cold.
  const leave = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  // ?you=<seat>: whose replay this is (the profile's links say so), for the timeline.
  const you = search.get("you");
  if (replay) return <MatchReplay match={replay.match} initialRound={round} onExit={leave} youIds={you ? [you] : undefined} />;
  return (
    <div className={styles.message}>
      {error === null && <p>Loading replay…</p>}
      {error === "gone" && <p>This replay is no longer available. Replays are kept for {REPLAY_DAYS} days.</p>}
      {error !== null && error !== "gone" && <p>Could not load this replay. Check your connection and try again.</p>}
      {error !== null && <button className="btn btn-primary" onClick={leave}>Back</button>}
    </div>
  );
}
